import {
  getCameraConfigForDomain,
  getAlertConfigForDomain,
  getAvailableDetectables, getNotificationTargetsForDomainAndUser,
} from '@/libraries/api/dna'
import { parseAlertConfig, parseCameraConfig } from '../../components/dna-configuration/dnaFormHelper'

export const DnaConfigurationModule = {
  namespaced: true,
  state: {
    alertsById: {},
    camerasById: {},
    notificationsById: {},
    conditionsById: {},
    cameraDetectablesById: {},
    detectables: [],
    currentCameraUUID: undefined,
    currentAlertId: undefined,
    copiedConfig: {},
    notificationTargets: [],
  },
  mutations: {
    setCurrentAlertId (state, alertId) {
      state.currentAlertId = alertId
    },
    setCurrentCameraUUID (state, uuid) {
      state.currentCameraUUID = uuid
    },
    setAlerts (state, alerts) {
      state.alertsById = { ...state.alertsById, ...alerts }
    },
    setCameras (state, cameras) {
      state.camerasById = { ...state.camerasById, ...cameras }
    },
    setNotifications (state, notifications) {
      state.notificationsById = { ...state.notificationsById, ...notifications }
    },
    setConditions (state, conditions) {
      state.conditionsById = { ...state.conditionsById, ...conditions }
    },
    setCameraDetectables (state, cameraDetectables) {
      state.cameraDetectablesById = { ...state.cameraDetectablesById, ...cameraDetectables }
    },
    setDetectables (state, detectables) {
      state.detectables = detectables
    },
    setCopiedConfig (state, config) {
      state.copiedConfig = config
    },
    setNotificationTargets (state, notificationTargets) {
      state.notificationTargets = notificationTargets
    },
    clear (state) {
      state.alertsById = {}
      state.camerasById = {}
      state.notificationsById = {}
      state.conditionsById = {}
      state.cameraDetectablesById = {}
      state.detectables = []
      state.notificationTargets = []
    },
    removeAlertById (state, id) {
      const alerts = Object.keys(state.alertsById).reduce((prev, curr) => {
        prev.push(curr)
        return prev
      }, [])
        .filter(alertId => alertId !== id)
        .reduce((prev, curr) => {
          prev[curr] = state.alertsById[curr]
          return prev
        }, {})
      state.alertsById = alerts
    },
  },
  getters: {
    currentDomainConfig (state) {
      return {
        alertsById: state.alertsById,
        camerasById: state.camerasById,
        notificationsById: state.notificationsById,
        conditionsById: state.conditionsById,
        cameraDetectablesById: state.cameraDetectablesById,
        detectables: state.detectables,
      }
    },
    cameraEvents (state) {
      const events = state.cameraAlerts
      return events
    },
    cameraAlerts (state) {
      return state.cameraAlerts
    },
    cameraDetections (state) {
      return state.cameraDetections
    },
    detectableForDescription (state) {
      return (description) => state.detectables.find(det => det.class_name === description)
    },
    copiedConfig (state) {
      return state.copiedConfig
    },
  },
  actions: {
    async getDetectables ({ commit, rootState }) {
      const domainUUID = rootState.data.domains.current.uuid
      getAvailableDetectables(domainUUID)
        .then(res => {
          commit('setDetectables', res.data.detectables)
        })
        .catch(error => console.error(`Error loading detectables: `, error))
    },
    async getCameraConfigs ({ commit, rootState }, refresh) {
      const domainUUID = rootState.data.domains.current.uuid
      getCameraConfigForDomain(domainUUID, refresh)
        .then(res => {
          const parsed = parseCameraConfig(res.data.data)
          commit('setCameras', parsed.camerasById)
          commit('setCameraDetectables', parsed.cameraDetectablesById)
        })
        .catch(error => console.error(`Error loading cameras: `, error))
    },
    async getAlertConfigs ({ commit, rootState }, refresh) {
      const domainUUID = rootState.data.domains.current.uuid
      getAlertConfigForDomain(domainUUID, refresh)
        .then(res => {
          const mappedAlerts = parseAlertConfig(res.data.data)
          commit('setAlerts', mappedAlerts.alertsById)
          commit('setNotifications', mappedAlerts.notificationsById)
          commit('setConditions', mappedAlerts.conditionsById)
        })
        .catch(error => console.error(`Error loading cameras: `, error))
    },
    async getNotificationTargets({ commit, rootState }) {
      const domainUUID = rootState.data.domains.current.uuid
      try {
        const result = await getNotificationTargetsForDomainAndUser(domainUUID)
        commit('setNotificationTargets', result.data.targets)
      } catch (e) {
        console.error('Error loading notification targets', e)
      }
    },
    async loadDomainConfiguration ({ commit, dispatch, state }, refresh = false) {
      commit('clear')
      await dispatch('getDetectables')
      await dispatch('getCameraConfigs', refresh)
      await dispatch('getAlertConfigs', refresh)
      await dispatch('getNotificationTargets')
    },
  },
}
